@if (!isServer) {
    <section
        class="wrapper-ad"
        [ngClass]="{
            'side-ad': sideAd() && (url.activeAngularPage === AngularPages.MainHomePage || url.activeAngularPage === AngularPages.Home),
        }"
    >
        @if (closeable() && isAdLoaded()) {
            <button type="button" class="close-ad-position" (click)="closeAdContainer($event)" title="Close footer advertisement" aria-label="Close footer advertisement">
                <mat-icon aria-hidden="true">keyboard_arrow_down</mat-icon>
            </button>
        }
        <section
            [id]="tagCode()"
            [ngStyle]="{
                'min-width.px': adWidth(),
                'min-height.px': adHeight(),
                'width.px': adWidth(),
                'height.px': adHeight(),
            }"
        ></section>
    </section>
}
